import SvgWrapper from './SvgWrapper';
import { AllergnIconProps } from './types';

const CeleryIcon = ({
  innerColor = '#fefefe',
  outerColor = '#4cad3b',
  ...props
}: AllergnIconProps) => {
  const style = {
    fill: innerColor,
  };

  return (
    <SvgWrapper {...props}>
      <g
        id="Grupo_115"
        data-name="Grupo 115"
        transform="translate(-381.5 -2094)"
      >
        <g
          id="Rectángulo_24"
          data-name="Rectángulo 24"
          transform="translate(381.5 2094)"
          fill="#fff"
          stroke="#000"
          stroke-width="1"
        >
          <rect width="27" height="27" rx="2" stroke="none" />
          <rect x="0.5" y="0.5" width="26" height="26" rx="1.5" fill="none" />
        </g>
        <g id="celery" transform="translate(388.65 2101.438)">
          <path
            id="Trazado_9115"
            data-name="Trazado 9115"
            d="M83.9,270.687a.248.248,0,1,0-.175-.073A.25.25,0,0,0,83.9,270.687Zm0,0"
            transform="translate(-81.573 -263.489)"
          />
          <path
            id="Trazado_9116"
            data-name="Trazado 9116"
            d="M255.654,223.293a.248.248,0,1,0,.175.073A.25.25,0,0,0,255.654,223.293Zm0,0"
            transform="translate(-249.07 -217.754)"
          />
          <path
            id="Trazado_9117"
            data-name="Trazado 9117"
            d="M12.517,3.433A.85.85,0,0,0,12.452,2.3h0a.851.851,0,0,0-.5-1.21.989.989,0,0,0-1.683-.8.971.971,0,0,0-.081.092,1.063,1.063,0,0,0-1.665.655L8.5,1.028A1.2,1.2,0,0,0,6.352.58.935.935,0,0,0,5.17,2.017l.009.008.008.009.055.055a1.126,1.126,0,0,1,0,1.591L2.849,6.075a.248.248,0,0,0,.351.351L5.594,4.032a1.623,1.623,0,0,0,0-2.293l-.055-.055-.009-.008-.008-.009a.439.439,0,1,1,.684-.54.248.248,0,0,0,.447-.055A.706.706,0,0,1,7.825.788a.7.7,0,0,1,.206.463.248.248,0,0,0,.232.235.437.437,0,0,1,.281.127.442.442,0,0,1,.076.1l0,.009a.438.438,0,1,1-.792.375.248.248,0,0,0-.454.2.935.935,0,1,0,1.689-.8.566.566,0,0,1,.9-.658.572.572,0,0,1,.077.1A.248.248,0,0,0,10.5.866a.493.493,0,1,1,.923.333.248.248,0,0,0,.248.353.354.354,0,0,1,.284.6l-.011.009-.007.006A.248.248,0,0,0,12,2.582a.353.353,0,0,1,.106.573l-.03.026a.248.248,0,0,0-.061.314.319.319,0,0,1-.051.378,1.042,1.042,0,0,0-.08-.091,1.059,1.059,0,0,0-1.5,0l-.028.029a.926.926,0,0,0-.838.25c-.02.02-.039.041-.057.063a.834.834,0,0,0-.328-.386l.892-.892a.392.392,0,0,1,.554,0,.248.248,0,0,0,.351-.351.889.889,0,0,0-1.255,0l-.79.79a.824.824,0,0,0-.127-.164.838.838,0,0,0-1.115-.061A.882.882,0,0,0,6.42,4.1L1.959,8.56a1.319,1.319,0,0,0-.379,1.1.5.5,0,0,1-.945.284l-.052-.1A.831.831,0,0,1,.74,8.885L1.8,7.829a.248.248,0,0,0-.351-.351L.39,8.534a1.327,1.327,0,0,0-.251,1.528l.052.1a.984.984,0,0,0,.223.293.265.265,0,0,0,.022.025l1.226,1.226A1.405,1.405,0,0,0,4.04,10.96a2.437,2.437,0,0,1,.681-1.312L7.083,7.286a.739.739,0,0,1,1.046,0l.049.049a1.237,1.237,0,0,0,1.656.083,1.13,1.13,0,0,0,1.739-.951,1.138,1.138,0,0,0-.014-.18.92.92,0,0,0,.634-1.571L12.175,4.7a1.065,1.065,0,0,0-.005-.362.812.812,0,0,0,.347-.9Zm-.676,2.234a.425.425,0,0,1-.6,0l0,0a.248.248,0,1,0-.352.35l.006.006a.634.634,0,0,1-.9.891.248.248,0,0,0-.351,0,.245.245,0,0,0-.031.038.248.248,0,0,0-.038.031.74.74,0,0,1-1.046,0l-.049-.049a1.235,1.235,0,0,0-1.747,0L4.37,9.3a2.931,2.931,0,0,0-.819,1.578.909.909,0,0,1-1.539.487l-.673-.673.055-.016a1,1,0,0,0,.635-.634A2.129,2.129,0,0,0,3.293,9.43L6.069,6.654A.248.248,0,0,0,5.718,6.3L2.942,9.079a1.633,1.633,0,0,1-.874.453.825.825,0,0,1,.243-.621L6.7,4.525a.248.248,0,0,0,.3-.39.387.387,0,0,1,.524-.568.248.248,0,0,0,.365-.047.337.337,0,0,1,.039-.047.34.34,0,0,1,.57.326.248.248,0,0,0,.221.309.34.34,0,0,1,.214.58.346.346,0,0,1-.048.04.248.248,0,0,0-.1.261A.465.465,0,0,1,8,5.424a.248.248,0,0,0-.351.351.961.961,0,0,0,1.639-.743L9.3,5.018a.915.915,0,0,0,.218.346.248.248,0,1,0,.351-.351.425.425,0,0,1,.476-.687.248.248,0,0,0,.312-.094.563.563,0,0,1,.986.062l0,.01a.559.559,0,0,1,.016.411.248.248,0,0,0,.1.292.424.424,0,0,1,.076.661Zm0,0"
            transform="translate(0 0)"
          />
        </g>
      </g>
    </SvgWrapper>
  );
};

export default CeleryIcon;
